
import Utility from '@/components/Passenger/models/Utility';
import RideitChangeRequest, { RideitChangeRequestStatus } from '@/models/Rideit/RideitChangeRequest';
import Routes from '@/Routes';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RideitChangeRequestDialog extends Vue {
  @Prop({ required: true }) private value: boolean;
  @Prop({ required: true }) private changeRequest: RideitChangeRequest | null;
  @Prop({ default: () => [] }) private utilityOptions: Utility[];

  get dialogVisible() {
    return this.value;
  }
  set dialogVisible(newValue: boolean) {
    this.$emit('input', newValue);
  }

  get statusColor() {
    switch (this.changeRequest?.status) {
      case RideitChangeRequestStatus.Approved: return 'success';
      case RideitChangeRequestStatus.Rejected: return 'error';
      default: return 'warning';
    }
  }

  get title() {
    return this.$t('rideIt.changeRequests.dialogTitle');
  }

  get parsedAddedUtilities(): number[] {
    if (!this.changeRequest?.addedUtilities) return [];
    return this.changeRequest.addedUtilities.split(',').map(s => Number.parseInt(s.trim())).filter(Boolean);
  }

  get parsedRemovedUtilities(): number[] {
    if (!this.changeRequest?.removedUtilities) return [];
    return this.changeRequest.removedUtilities.split(',').map(s => Number.parseInt(s.trim())).filter(Boolean);
  }

  utilityTitle(utilityId: number) {
    const utility = this.utilityOptions.find(u => u.id === utilityId);
    return utility
      ? this.$i18n.translate('utility.title.' + utility.title, utility.title)
      : '';
  }

  openPassenger() {
    if (!this.changeRequest?.passengerId) return;
    this.$router.push({
      name: Routes.editPassengerRoute.name,
      params: { passengerId: this.changeRequest.passengerId.toString() },
    });
  }

  approve() {
    this.$emit('approve', this.changeRequest);
    this.closeDialog();
  }

  reject() {
    this.$emit('reject', this.changeRequest);
    this.closeDialog();
  }

  closeDialog() {
    this.dialogVisible = false;
  }
}
